<div class="gl-visor-image" [ngClass]="{ open: toogleVisor }">
  <div class="gl-visor-image__close" (click)="close()">
    <span class="glicon-close"></span>
  </div>
  <div class="gl-visor-image__item">
    <img src="{{ img }}" alt="" />
  </div>
</div>
